// extracted by mini-css-extract-plugin
export default {"rating":"kE-z","numberOfStars":"lE-z","count":"mE-z","barGraphSpacing":"nE-z","barGraph":"oE-z"};